const SettingsEarningEvents = props => {

  let earningEvents = JSON.parse( props.earningEvents );

  const eventsRepeater = tangibleFields.render({
    type: 'repeater',
    name: 'event_issuance_criteria',
    value: earningEvents,
    layout: 'block',
    sectionTitle: 'Content',
    useSwitch: 'true',
    fields: [{
      type: 'combo-box',
      name: 'content_type',
      label: 'Content Type',
      choices: props.contentChoices
    }, {
      type: 'combo-box',
      name: 'earning_event',
      label: 'Event',
      isAsync: true,
      ajaxAction: 'tgbl_content_type_events',
      dependent: true,
      asyncArgs: {
        content_type: '{{content_type}}'
      }
    }, {
      type: 'combo-box',
      name: 'point_types',
      label: 'Default Accreditation Point Types',
      multiple: true,
      choices: props.pointTypes
    }, {
      type: 'text',
      name: 'accreditation_code_label',
      label: 'Accreditation code label',
    }, {
      type: 'earningEventFields',
      name: 'accreditation_fields',
      value: [],
      layout: 'custom',

    }],
    wrapper : {
      class: 'earning-event-repeater'
    }
  });

  return (
    <div className="tgbl-accreditation-ui">
      <div className="tgbl-event-issuance-criteria-block tgbl-field-block">
        {eventsRepeater}
      </div>
    </div>
  )
}

export { SettingsEarningEvents }
